import { render, staticRenderFns } from "./MenuProjetos.vue?vue&type=template&id=6117d801"
import script from "./MenuProjetos.vue?vue&type=script&lang=js"
export * from "./MenuProjetos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports